import sc from './MyriadPro-SemiCondensed'
import bold from './MyriadPro-SemiExtended-Bold'
import regular from './MyriadPro-SemiExtended-Regular'

export default {
  addFonts() {
    sc.addFont()
    bold.addFont()
    regular.addFont()
  }
}


// WEBPACK FOOTER //
// ./scripts/vue/fonts/fonts.jspdf.js